/**
 * Strip Latin diacritics (macron, acute, etc.) so "Bādhak" matches "Badhak" / letter B.
 */
export function stripDiacritics(text: string): string {
  return text
    .normalize("NFD")
    .replace(/\p{M}+/gu, "")
    .normalize("NFC");
}

/** Lowercase + trim + strip diacritics — for sort, search, and equality. */
export function normalizeForCompare(text: string): string {
  return stripDiacritics(text.trim().toLowerCase());
}

/** First A–Z letter of a word after stripping diacritics (for browse index / badges). */
export function wordFirstLetter(word: string): string {
  const base = stripDiacritics(word.trim());
  if (!base) {
    return "";
  }
  return base.charAt(0).toUpperCase();
}

export function textIncludesNormalized(
  haystack: string | null | undefined,
  normalizedNeedle: string
): boolean {
  if (!normalizedNeedle) {
    return true;
  }
  return normalizeForCompare(haystack ?? "").includes(normalizedNeedle);
}
